import React, {
    //  useEffect,
    useState
} from "react";
// import ImageWithBasePath from '../../core/data/img/ImageWithBasePath'
// import Breadcrumbs from '../common/breadcrumbs'
// import { useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";
import { all_routes } from "../router/all_routes";
// import { getBooking } from "../../core/data/redux/action";
// import { RootState } from "../../core/data/redux/store";
// import Lottie from "lottie-react";
// import Loader from "../../core/data/img/car_loading.json";
import Box from '@mui/material/Box';

import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { BookingSteps } from "../../core/data/redux/actions/commonActions";
// import dayjs from 'dayjs';
import { Link } from "react-router-dom";


const PaymentPending = () => {

    const routes = all_routes;
    //  const dispatch = useDispatch(); 
    // const { bookingDetailLoading,   } = useSelector(
    //     (state: RootState) => ({
    //           bookingDetailLoading: state.booking.bookingDetailLoading,
    //     })
    // );

    // const navigate = useNavigate();
    const [step] = useState(5);

    return (
        <div>

            {
                // bookingDetailLoading ?
                //     <div className="d-flex justify-content-center align-items-center">
                //         <Lottie animationData={Loader} loop={true} style={{ width: 300, height: 300 }} />
                //     </div>
                //     :
                <div className="booking-new-module">
                    <div className="container">
                        <div className="booking-wizard-head mb-0">
                            <div className="row align-items-center">
                                <div className="col-xl-4 col-lg-3">
                                    <div className="booking-head-title d-none d-md-block">
                                        <h4  >Reserve Your Car</h4>
                                    </div>
                                </div>
                                <div className="col-xl-8 col-lg-9 justify-content-left display-grid">

                                    <Box className="px-0 " sx={{ width: '100%' }}>
                                        <Stepper activeStep={step} alternativeLabel
                                            sx={{

                                                ".MuiStep-root": { width: "5rem" },
                                                ".MuiStepIcon-root.Mui-completed": { color: "#009FDF" },
                                                ".MuiStepIcon-root.Mui-active": { color: "#009FDF" },

                                            }}

                                        >
                                            {BookingSteps?.map((label) => (
                                                <Step key={label}   >
                                                    <StepLabel>{label}</StepLabel>
                                                </Step>
                                            ))}
                                        </Stepper>
                                    </Box>

                                </div>
                            </div>
                        </div>
                        <div className="booking-card my-5">
                            <div className="success-book">
                                <span className="success-icon">
                                    <i className="fa-solid fa-check-double" />
                                </span>
                                <h6 className="fw-bold">Your payout details have been saved successfully. Our team will contact you soon to complete the payment.</h6>
                                {/* <h6 className="order-no">Order Number : <span>#{bookingDetail?.booking_id}</span></h6> */}
                            </div>


                            <div className="m-4 text-center">

                                <button type="button"    className="text-white bg-primary mt-2 p-2 px-5 border-0" style={{ cursor: "pointer" }}>

                                    <Link to={routes.homeOne} className="text-white" >Home</Link>  </button>
                            </div>

                        </div>

                    </div>
                </div>
            }


        </div>
    )
}

export default PaymentPending